module.exports = __webpack_public_path__ + "assets/img/case-history-img.bf64dc03.png";